/**
 * Shared number formatters for the dashboards. Single source of truth so the
 * compact-abbreviation rule (K/M/B) doesn't drift between sibling tabs.
 */

/** Compact abbreviation: 1_234_567 → "1.2M". Non-numeric/non-finite → "—" (a real 0 → "0"). */
export const fmtCompact = (n: number | undefined | null): string => {
  if (typeof n !== 'number' || !Number.isFinite(n)) return '—';
  const abs = Math.abs(n);
  if (abs >= 1e9) return `${(n / 1e9).toFixed(1)}B`;
  if (abs >= 1e6) return `${(n / 1e6).toFixed(1)}M`;
  if (abs >= 1e3) return `${(n / 1e3).toFixed(1)}K`;
  return `${Math.round(n)}`;
};

/** Thousands-grouped integer: 1234567 → "1,234,567". Non-finite → "—". */
export const fmtNum = (n: number | undefined | null): string =>
  typeof n === 'number' && Number.isFinite(n) ? Math.round(n).toLocaleString('en-US') : '—';

/** Whole-dollar USD: 1234 → "$1,234". */
export const fmtUsd = (n: number | undefined | null): string =>
  '$' + (n ?? 0).toLocaleString('en-US', { maximumFractionDigits: 0 });
